import firebase from 'firebase';

export default{

    mutations: {
        setProjects(state, payload) {
            this.state.projects = payload;
            this.state.updatecount++;
        },
        addProject(state, payload) {
            this.state.projects.push(payload);
            if (payload.ID === this.state.currentproject.ID) {
                //alert("f2 " + payload.name);
                this.state.currentproject = payload;
                this.state.updatecount++;
            }
        },
        cutProject(state,payload){
            const deleted = this.state.projects.find(project => project.ID === payload.ID);
            const index = this.state.projects.indexOf(deleted);
            this.state.projects.splice(index, 1);
            this.state.updatecount++;
        },
        changedShare(state,payload){
            alert('check changedShare');
            var changed= this.state.projects.find(project => project.ID === payload.ID);
            var isselected = changed.IsSelected;
            changed.val = payload.val;
            changed.IsSelected = isselected;    
            this.state.updatecount++;
        },
    },
    actions:{
        setProject({ state }, payload) {
            var dat = { ...payload };
            delete(dat.ID);
            firebase.database().ref('users/' + this.state.user.uid + '/projects/' + payload.ID ).set(dat);
        },
        addProject({ state }, payload) {
            firebase.database().ref('users/' + this.state.user.uid + '/projects').push(payload);
            
        },
        newProject({ state }, payload) {
            firebase.database().ref('projects').push(payload).then((snap) => {
                var userlink={projectid:snap.key, name:payload.name, created:payload.created, description:payload.description, rights:'admin'};
                firebase.database().ref('users/' + this.state.user.uid + '/projects').push(userlink);
            })
        }
    }
}